import React, { PureComponent, Fragment } from 'react';
import { Table } from 'react-bootstrap';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment';

import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import DisplayOnlyInput from '../../../../../shared/components/formComponents/inputs/DisplayOnlyInput';
import VerbSelect from '../../../../../shared/components/formComponents/inputs/VerbSelect';

export default class HiddenLearningAssetsTable extends PureComponent {
    static propTypes = {
        fields: PropTypes.object,
        hiddenLearningAssetOptions: PropTypes.array,
        handleHiddenLearningAssetChange: PropTypes.func,
        selectedHiddenLearningAsset: PropTypes.object,
        handleAddHiddenLearningAsset: PropTypes.func,
        currentValues: PropTypes.shape({
            hiddenLearningAssets: PropTypes.array
        })
    };

    _renderTable = (fields) => {
        if (fields && fields.length) {
            return (
                <Table striped={false} bordered={false} className={'hidden-learning-asset-table'}>
                    <thead>
                        <tr>
                            <th className={'buttonCell'}>Actions</th>
                            <th>Activity Name</th>
                            <th>Date Hidden</th>
                        </tr>
                    </thead>
                    <tbody>{this._renderTableRows(fields)}</tbody>
                </Table>
            );
        }
        return null;
    };

    _renderTableRows = (fields) => {
        const {
            currentValues: { hiddenLearningAssets = [] }
        } = this.props;
        const rows = [];

        let hiddenDate;
        if (fields && fields.length) {
            fields.forEach((asset, index) => {
                hiddenDate = hiddenLearningAssets[index] && hiddenLearningAssets[index].selectedDateTime;

                rows.push(
                    <tr key={index} className={'hidden-learning-asset-row'}>
                        <td className={'buttonCell'}>
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-trash'}
                                title={'Remove Hidden Asset'}
                                onClick={() => fields.remove(index)}
                            />
                        </td>

                        <td>
                            <Field name={`${asset}.name`} component={DisplayOnlyInput} />
                        </td>
                        <td>{moment(hiddenDate).format('MMM Do YYYY')}</td>
                    </tr>
                );
            });
        }

        return rows;
    };

    render() {
        const {
            hiddenLearningAssetOptions,
            selectedHiddenLearningAsset,
            handleHiddenLearningAssetChange,
            handleAddHiddenLearningAsset,
            fields
        } = this.props;

        return (
            <Fragment>
                <label className={'form-label'}>Hidden Activities</label>
                <label className={'form-description light'}>
                    These Activities will not be displayed on the Library page.
                </label>
                <br />
                <div>
                    <div className={'row'}>
                        <div className={'col-8'}>
                            <VerbSelect
                                placeholder={'Select Hidden Activity'}
                                className={'reactSelect'}
                                value={selectedHiddenLearningAsset._id || ''}
                                labelKey={'name'}
                                valueKey={'_id'}
                                onChange={(asset) => handleHiddenLearningAssetChange(asset)}
                                options={hiddenLearningAssetOptions}
                            />
                        </div>
                        <div className={'col-4'}>
                            <VerbButton
                                className={'full-width'}
                                fontAwesomeIcon={'fa-plus'}
                                disabled={!selectedHiddenLearningAsset._id}
                                onClick={() => handleAddHiddenLearningAsset(fields, selectedHiddenLearningAsset)}
                            >
                                Hide Activity
                            </VerbButton>
                        </div>
                    </div>
                    {this._renderTable(fields)}
                </div>
            </Fragment>
        );
    }
}
